import styled from 'styled-components';

export const EntityName = styled.span<{ $isDeleted?: boolean }>`
  color: ${({ $isDeleted, theme }) => ($isDeleted ? theme.colors.cflowerBlue : 'unset')};
`;
